import { normalizeLocale } from "../i18n";
import type { Locale } from "../i18n/types";

const LANGUAGE_KEY = "caylet-ip-language";

export function getSavedLocale(storage: Pick<Storage, "getItem"> = localStorage): Locale | null {
  try {
    return normalizeLocale(storage.getItem(LANGUAGE_KEY));
  } catch {
    return null;
  }
}

export function saveLocale(locale: Locale, storage: Pick<Storage, "setItem"> = localStorage): void {
  try {
    storage.setItem(LANGUAGE_KEY, locale);
  } catch {
    // Language persistence is optional when storage is blocked.
  }
}
